import { connect } from "react-redux";
import injectIntl from "../../../../common/helpers/injectIntl";

import { post } from "../../../actions/general";
import { addNewScore, removeScore, editTask } from "../../../store/plan/actions";
import editPlanScore from "../../../store/plan/actions/editPlanScore";

import LoadableComponent from "./lazy";

const mapDispatchToProps = {
    post,
    addNewScore,
    removeScore,
    editPlanScore,
    editTask,
};

export default connect(null, mapDispatchToProps)(injectIntl(LoadableComponent));
